import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useTranslation } from '../../context/I18nContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiLinkedin } = FiIcons;

export const Footer = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isDashboard = location.pathname.includes('/dashboard');

  if (isDashboard) return null;

  return (
    <footer className="bg-white border-t border-zinc-100 pt-24 pb-12 overflow-hidden">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16 mb-24">
          {/* Brand Identity */}
          <div className="md:col-span-4">
            <div className="text-2xl font-bold tracking-tight text-zinc-900 flex items-center gap-3 mb-8">
              <div className="w-9 h-9 bg-zinc-900 rounded-xl flex items-center justify-center">
                <span className="text-white text-xl leading-none mt-[-2px] font-black">f</span>
              </div>
              Foodrolla
            </div>
            <p className="text-zinc-500 text-sm leading-relaxed max-w-xs mb-8">
              {t('footer.description')}
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.linkedin.com/in/maikewarner/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-zinc-100 flex items-center justify-center text-zinc-400 hover:text-zinc-900 hover:border-zinc-900 transition-all duration-300"
              >
                <SafeIcon icon={FiLinkedin} className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Navigation Columns */}
          <div className="md:col-span-2">
            <h4 className="text-[10px] font-black uppercase tracking-[0.2em] text-zinc-900 mb-8">
              {t('footer.company')}
            </h4>
            <ul className="space-y-4">
              <li><Link to="/about" className="text-sm text-zinc-500 hover:text-zinc-900 transition-colors">{t('footer.about')}</Link></li>
              <li><Link to="/mission" className="text-sm text-zinc-500 hover:text-zinc-900 transition-colors">{t('footer.mission')}</Link></li>
              <li><Link to="/marketplace" className="text-sm text-zinc-500 hover:text-zinc-900 transition-colors">{t('footer.restaurants')}</Link></li>
              <li><Link to="/suppliers" className="text-sm text-zinc-500 hover:text-zinc-900 transition-colors">{t('footer.suppliers')}</Link></li>
            </ul>
          </div>

          {/* Support Column */}
          <div className="md:col-span-2">
            <h4 className="text-[10px] font-black uppercase tracking-[0.2em] text-zinc-900 mb-8">
              {t('footer.support')}
            </h4>
            <ul className="space-y-4">
              <li><Link to="/faq" className="text-sm text-zinc-500 hover:text-zinc-900 transition-colors">{t('footer.faq')}</Link></li>
              <li><Link to="/privacy" className="text-sm text-zinc-500 hover:text-zinc-900 transition-colors">{t('footer.privacy')}</Link></li>
            </ul>
          </div>

          {/* Contact Section */}
          <div className="md:col-span-4">
            <h4 className="text-[10px] font-black uppercase tracking-[0.2em] text-zinc-900 mb-8">
              {t('footer.contact')}
            </h4>
            <p className="text-sm text-zinc-500 mb-4 font-normal">
              {t('footer.contactText')}
            </p>
            <p className="text-sm text-zinc-500 font-normal">
              hello.foodrolla@gmail.com
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-zinc-100 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-[10px] font-bold text-zinc-400 uppercase tracking-widest">
            © {new Date().getFullYear()} Foodrolla. {t('footer.tagline')}
          </p>
          <div className="flex gap-8">
            <span className="text-[9px] font-black text-zinc-300 uppercase tracking-widest">Amsterdam</span>
            <span className="text-[9px] font-black text-zinc-300 uppercase tracking-widest">Noordwijk</span>
            <span className="text-[9px] font-black text-zinc-300 uppercase tracking-widest">Maastricht</span>
          </div>
        </div>
      </div>
    </footer>
  );
};